import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { ELEVATION } from '@openx/components-core/lib/theme/elevation.ts';

type SimpleMetricProps = {
  title: string;
  value: string;
  'data-test'?: string;
};

export const SimpleMetric = ({ title, value, 'data-test': dataTest }: SimpleMetricProps) => {
  return (
    <Card
      data-test={dataTest}
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '4px',
        boxShadow: ELEVATION.elevation0,
        height: '112px',
        flex: 1,
      }}
    >
      <CardContent sx={{ p: 1.5 }}>
        <Typography
          variant="body2"
          sx={{
            mb: 0.5,
            color: 'text.secondary',
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body1Bold"
          component="span"
          sx={{ fontSize: 28 }}
          data-test={dataTest ? `${dataTest}-value` : undefined}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};
